import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import '../admin.css';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post('/api/login', { username, password });
            localStorage.setItem('adminToken', res.data.token);
            navigate('/admin');
        } catch (err) {
            toast.error('Ошибка авторизации! Проверьте логин и пароль.');
        }
    }

    return (
        <div className="admin-login-wrap">
            <div className="admin-login-box">
                <h2>YOONIX.SHOP ADMIN</h2>
                <form onSubmit={handleLogin}>
                    <input type="text" placeholder="Логин (shopyoonix)" value={username} onChange={e=>setUsername(e.target.value)} required />
                    <input type="password" placeholder="Пароль (yoonixshop)" value={password} onChange={e=>setPassword(e.target.value)} required />
                    <button type="submit">Войти в систему</button>
                </form>
                <a href="/" className="back-link">&larr; Вернуться в магазин</a>
            </div>
        </div>
    );
};

export default Login;